export default __webpack_public_path__ + "static/media/fake7.9896284c.jpg";